import { updateKeyInStore } from 'App';
import { CitizenshipStateValues, updateKey } from '../slice';

export const uploadFields: IBaseField<keyof CitizenshipStateValues>[] = [
  {
    type: 'upload',
    name: 'greencardCopy',
    label: 'Please upload a copy of the Green Card',
    tooltip: '',
    comment: true,
    effect: updateKeyInStore(updateKey),
    dependentOn:
      'taxQuestionnaire.personal_details.the_basics.citizenship.values.greenCardHolderThisYear',
    predicate: (value) => value === 'yes',
  },
];
